import { Inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { EmergencyDto } from '@shared/interfaces/dtos/emergencies';

@Injectable({ providedIn: 'root' })
export class EmergenciesService extends BaseHttpService {
  protected endPoint: string = 'Global/NiveauxUrgences';

  public fetchEmergencies(): Observable<EmergencyDto[]> {
    return this.http.get<EmergencyDto[]>(this.buildURL());
  }
}
